import React, {PureComponent } from 'react';

class TimeLineBlock extends PureComponent {
    constructor(props){
        super(props);
        ['handleClick'].forEach(fn => this[fn] = this[fn].bind(this));    
    }
    handleClick(){
        let {checkStatus, checkSelected, time, date, handleClick} = this.props;
        if(!checkStatus || checkSelected) return ;
        handleClick(time, date);
    }
    render() {
        let {checkSelected, checkStatus, handleMouseEnter, handleMouseLeave, date, time} = this.props;    
        return  (
            <div 
                className={`
                    block
                    ${!checkStatus ? 'block-disabled': 'block-available'}
                    ${checkSelected ? 'block-selected' : ''}
                `} 
                onClick={this.handleClick}
                onMouseEnter={e => handleMouseEnter(e, date, time)}
                onMouseLeave={handleMouseLeave} 
            ></div>
        )
    }
}


export default TimeLineBlock;